const overviewGeneralStockTableHeaders = [
  {
    id: 'status',
    group: 'Status',
    canPrint: true
  },
  {
    id: 'cd',
    group: 'CD',
    canPrint: true,
    align: 'right'
  },
  {
    id: 'loja',
    group: 'Loja',
    canPrint: true,
    align: 'right'
  },
  {
    id: 'total',
    group: 'Total',
    canPrint: true,
    align: 'right'
  }
]

export default overviewGeneralStockTableHeaders
